import Int16 from './Integers/Int16';
export default function asInt16(value) {
    return new Int16(value);
}
